var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ]
    },
    [
      _c("v-layout", { staticClass: "mb-4", attrs: { row: "", wrap: "" } }, [
        _c(
          "div",
          { attrs: { align: "left" } },
          [
            _c("v-flex", { attrs: { md12: "" } }, [
              _c("h2", { staticClass: "h2_title" }, [
                _vm._v("Resumen de asignaciones")
              ])
            ])
          ],
          1
        )
      ]),
      _c("v-divider"),
      _c("ag-grid-vue", {
        staticClass: "ag-theme-material",
        staticStyle: {
          width: "100%",
          height: "400px",
          "font-family": "'Asap', sans-serif"
        },
        attrs: {
          columnDefs: _vm.columnDefs,
          rowData: _vm.rowData,
          rowSelection: "multiple",
          suppressRowClickSelection: true
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }